const TriggerUserInteraction = {
  execute() {
    window.parent.postMessage({ eventName: 'user_interaction' }, '*');
  }
};

export default TriggerUserInteraction;
